<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.DESCRIPTION' | translate }}
  </div>
  <div class="control-container">
    {{ 'AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.TO_BRANCH_A' | translate }}
    <div class="input-container">
      <mat-slider class="slider" [max]="100" [min]="0" [step]="1" aria-labelledby="branch-a">
        <input
          matSliderThumb
          (valueChange)="valAChange($event)"
          [value]="valueForA"
          (blur)="valAChange(valueForA)"
          max="100"
          min="0"
        />
      </mat-slider>
      <glxy-form-field class="input">
        <input matInput [(ngModel)]="valueForA" type="number" (blur)="valAChange(valueForA)" />
      </glxy-form-field>
    </div>
  </div>
  <div class="control-container">
    {{ 'AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.TO_BRANCH_B' | translate }}
    <div class="input-container">
      <mat-slider class="slider" [max]="100" [min]="0" [step]="1" aria-labelledby="branch-b">
        <input matSliderThumb (valueChange)="valBChange($event)" [value]="valueForB" />
      </mat-slider>
      <glxy-form-field class="input">
        <input matInput [(ngModel)]="valueForB" type="number" (blur)="valBChange(valueForB)" />
      </glxy-form-field>
    </div>
  </div>
</div>
